function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M434 331H78C34.99 331 0 365.99 0 409C0 452.01 34.99 487 78 487H434C477.01 487 512 452.01 512 409C512 365.99 477.01 331 434 331ZM434 447H78C57.047 447 40 429.953 40 409C40 388.047 57.047 371 78 371H434C454.953 371 472 388.047 472 409C472 429.953 454.953 447 434 447Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M241.857 295.143C249.574 302.86 262.301 302.984 270.142 295.143L350.142 215.143C357.953 207.333 357.952 194.669 350.142 186.858C342.332 179.047 329.668 179.047 321.857 186.858L276 232.716V45C276 33.954 267.046 25 256 25C244.954 25 236 33.954 236 45V232.716L190.142 186.858C182.332 179.047 169.668 179.048 161.857 186.858C154.046 194.668 154.046 207.332 161.857 215.143L241.857 295.143Z",
  fill: "black"
});

var SvgExcel = function SvgExcel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 512 512",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExcel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/excel.5c44779f.svg";
export { ForwardRef as ReactComponent };